module.exports = __webpack_public_path__ + "img/SichBerührenLassen.f0f2398e.jpg";